export default __webpack_public_path__ + "static/Card15-dc66966965f4d8a2402815adee86cdf0.png";